import type { Question } from '@api/instant_survey/types';
import {
  Announcement,
  ExclamationTriangleIcon,
  HelpV2Icon,
  OverlayTriggerTooltip,
} from '@utilities';

import { getMaxDiffQuestionInfo } from '../../../../../../utilities/helpers';

import styles from './_index.module.scss';

interface MaxDiffWarningAnnouncementProps {
  question: Question;
}

const MaxDiffWarningAnnouncement = ({ question }: MaxDiffWarningAnnouncementProps) => {
  const { hasInsufficientCoverage } = getMaxDiffQuestionInfo(question);

  if (!hasInsufficientCoverage) return null;

  return (
    <Announcement
      className={styles['max-diff-warning-announcement']}
      icon={<ExclamationTriangleIcon />}
      text={
        <>
          <strong>Warning!</strong> Your current combination of attributes per set and sets per
          respondent will result in survey respondents not seeing all attributes.
          <OverlayTriggerTooltip content="The product of your attributes per set and sets per respondent should not be less than your total answer options.">
            <HelpV2Icon className={styles['max-diff-warning-announcement-help-icon']} />
          </OverlayTriggerTooltip>
        </>
      }
      variant="warn"
    />
  );
};

export default MaxDiffWarningAnnouncement;
